module.exports = __webpack_public_path__ + "static/workplace-fc664ed6812d4a4158e34e5040ad3654.jpg";